module.exports = __webpack_public_path__ + "media/images/settings-c1dbe465db534cf8b7b574d7093a2ebc.png";